module.exports = __webpack_public_path__ + "static/media/review.38cf2a70.png";